import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class CadenceText extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateCadenceText);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateCadenceText);
  }

  /**
   * Updates the cadence text.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateCadenceText = (event) => {
  
     
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newCadenceText = event.detail.data.html.querySelector('cadence-text .cadence');
  
    const currentCadenceText = this.querySelector('.cadence');

    if (!newCadenceText || !currentCadenceText) return;

    if (currentCadenceText.innerHTML !== newCadenceText.innerHTML) {
      currentCadenceText.replaceWith(newCadenceText);
    }
  };
}

if (!customElements.get('cadence-text')) {
  customElements.define('cadence-text', CadenceText);
}
